import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Type,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import {
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { DateTimeInputComponent } from './date-time-input.component';

interface DateTimePickerProps extends FormlyFieldProps {
  datepickerOptions?: {
    min?: Date;
    max?: Date;
  };
  minutesGap?: number;
}

export interface FormlyDateTimePickerFieldConfig
  extends FormlyFieldConfig<DateTimePickerProps> {
  type: 'datetimepicker' | Type<DateTimePickerComponent>;
}

@Component({
  selector: 'itc-formly-datetimepicker',
  template: `
    <div class="date-time-picker">
      <itc-date-time-input
        [formControl]="control"
        [id]="id"
        [label]="props.label"
        [required]="props.required"
        [hideRequiredMarker]="props.hideRequiredMarker === true"
        [min]="props.datepickerOptions?.min ?? null"
        [max]="props.datepickerOptions?.max ?? null"
        [minutesGap]="props.minutesGap ?? 5"
      />

      @if (showError) {
        <div class="ng-error date-time-picker__error">
          <formly-validation-message [field]="field" />
        </div>
      }
    </div>
  `,
  styles: [
    `
      .date-time-picker {
        margin-bottom: 0.5rem;
      }

      .date-time-picker__error {
        margin-top: 0.25rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DateTimeInputComponent, FormlyModule, ReactiveFormsModule],
})
export class DateTimePickerComponent
  extends FieldType<FieldTypeConfig<DateTimePickerProps>>
  implements OnInit
{
  control: UntypedFormControl;

  override defaultOptions = {
    props: {
      minutesGap: 5,
    },
  };

  ngOnInit(): void {
    this.control = this.formControl as UntypedFormControl;
  }
}
